import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN,
  FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN_ERROR,
  SET_WHERE_YOUR_CUSTOMERS_HAVE_BEEN,
} from '../constants';

const whereYourCustomersHaveBeen = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN),
    switchMap(() =>
      ajax({
        url: `${
          state$.value.auth.server
          }/report/custom-subcategories?${`&since=${
          encodeURIComponent(state$.value.home.sinceDate)
          }&until=${encodeURIComponent(state$.value.home.untilDate)}`}&v=${
          process.env.REACT_APP_VERSION
          }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_WHERE_YOUR_CUSTOMERS_HAVE_BEEN,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN_ERROR,
            error,
          })
        )
      )
    )
  );

export default whereYourCustomersHaveBeen;
